export default __webpack_public_path__ + "static/media/hybrid.5823864e.png";